import React from 'react';
// styles
import styled from 'styled-components';

const ConfigurationIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Configuration"
    className={className}
    role="img"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3943 5.19983C17.4678 5.19989 17.54 5.17967 17.6028 5.14138C17.6656 5.1031 17.7166 5.04824 17.7503 4.98284C17.7839 4.91744 17.7989 4.84402 17.7935 4.77066C17.7881 4.6973 17.7627 4.62684 17.7199 4.56703L14.8399 0.53503C14.7658 0.431235 14.6679 0.346657 14.5545 0.288348C14.4411 0.23004 14.3154 0.19969 14.1879 0.19983H9.99985C9.89377 0.19983 9.79203 0.241972 9.71701 0.316987C9.642 0.392001 9.59985 0.493743 9.59985 0.59983V4.79983C9.59985 4.90592 9.642 5.00766 9.71701 5.08267C9.79203 5.15769 9.89377 5.19983 9.99985 5.19983H17.3943Z"
      fill="#0140CD"
    />
    <path
      d="M0.599707 6.39981C0.49362 6.39981 0.391879 6.44195 0.316864 6.51697C0.24185 6.59198 0.199707 6.69372 0.199707 6.79981V17.7998C0.199707 18.012 0.283993 18.2155 0.434022 18.3655C0.584051 18.5155 0.787534 18.5998 0.999707 18.5998H17.7997C18.0119 18.5998 18.2154 18.5155 18.3654 18.3655C18.5154 18.2155 18.5997 18.012 18.5997 17.7998V6.79981C18.5997 6.69372 18.5576 6.59198 18.4825 6.51697C18.4075 6.44195 18.3058 6.39981 18.1997 6.39981H0.599707ZM9.79971 14.1998C9.79971 14.0937 9.84185 13.992 9.91686 13.917C9.99188 13.842 10.0936 13.7998 10.1997 13.7998H15.7997C15.9058 13.7998 16.0075 13.842 16.0826 13.917C16.1576 13.992 16.1997 14.0937 16.1997 14.1998V15.7998C16.1997 15.9059 16.1576 16.0076 16.0826 16.0827C16.0075 16.1577 15.9058 16.1998 15.7997 16.1998H10.1997C10.0936 16.1998 9.99188 16.1577 9.91686 16.0827C9.84185 16.0076 9.79971 15.9059 9.79971 15.7998V14.1998Z"
      fill="#0140CD"
    />
    <path
      d="M8.39985 0.59983C8.39985 0.493743 8.35771 0.392001 8.28269 0.316987C8.20768 0.241972 8.10594 0.19983 7.99985 0.19983H4.61185C4.48432 0.19969 4.35861 0.23004 4.24519 0.288348C4.13178 0.346657 4.03394 0.431235 3.95985 0.53503L1.07985 4.56703C1.03704 4.62684 1.01156 4.6973 1.00619 4.77066C1.00083 4.84402 1.0158 4.91744 1.04945 4.98284C1.0831 5.04824 1.13414 5.1031 1.19694 5.14138C1.25975 5.17967 1.3319 5.19989 1.40545 5.19983H7.99985C8.10594 5.19983 8.20768 5.15769 8.28269 5.08267C8.35771 5.00766 8.39985 4.90592 8.39985 4.79983V0.59983Z"
      fill="#0140CD"
    />
  </svg>
);

export default styled(ConfigurationIcon)``;
